import { PropertyDetailsModel } from "./../models/property_details";
import { addPopStateListener } from "ldp/common_platform/events/popstate";
import { markAsSeen } from 'shared_critical/propertySeen';
import { accordionClick } from '../../../../javascripts/shared_non_critical/accordion_tracking_helper';

MOVE.LDP.PropertyDetails = (function (LDP) {
    var controller = "property_details";
    var action = "show";
    var onReady;
    var status = MOVE.CONSTANTS.PROPERTY_STATUS;

    var init = function (options) {
      var data = (options || {}).data || MOVE.DataStore.getData('propertyDetails');
      MOVE.LDP.model = new PropertyDetailsModel(options || { data: data });
      addPopStateListener();
      onReady();
      markAsSeen(data.property_id);
      
      if (MOVE.DOMHelper.detectPageType() === 'ldp' && (MOVE_DATA.full_ldp_modules === 'V1' || MOVE_DATA.full_ldp_modules === 'V2')) {
        handleFullLdpAccordionClicks();
      }
    };

    var handleFullLdpAccordionClicks = function() { 
      var accordionsClasses = $('div.full-ldp-collasped-accordion');

      accordionsClasses.each(function() {
        var accordion = $(this);
        if (accordion) {
          accordion.on('click', function() {        
            accordionClick.call(this);
          });
        }
      });
    }

    var getPropertyStatus = function(data) {
      return (isSameDomain() ? getPropertyStatusByReferrer(data) : getPropertyStatusByData(data));
    };

    // Check if current and referrer URL is the same domain
    var isSameDomain = function() {
      var referrer = document.referrer;

      return (
        referrer.length &&
        referrer.indexOf(window.location.protocol + "//" + window.location.host) === 0
      );
    };

    // Infer property search status by referrer
    var getPropertyStatusByReferrer = function(data) {
      switch(document.referrer.split('/')[3]) {
        case 'realestateandhomes-search':  return status.forSale;
        case 'foreclosures':               return status.foreclosure;
        case 'soldhomeprices':             return status.recentlySold;
        case 'propertyrecord-search':      return status.propertyRecords;
        case 'newhomesconstruction':       return status.newPlan;
        default:                           return getPropertyStatusByData(data, true);
      }
    };

    // Infer property search status by data
    var getPropertyStatusByData = function(data, isValidreferrer) {
      var isForeclosure = data.is_foreclosure,
          isRecentlySold = (data.status_display || '').toLowerCase() === 'recently sold',
          isOffMarket = (data.status_display || '').toLowerCase() === 'off market';

      if (isForeclosure) {
        return status.foreclosure;
      }
      else if (isRecentlySold) {
        return status.recentlySold;
      }
      else if (isOffMarket) {
        if(isValidreferrer && isHomePageOrPropertyRecordSRP()) {
          // If user is coming from home estimates tab or has visited property records SRP previously,
          // then direct it to property records SRP
          return status.propertyRecords;
        } else {
          // If user is not coming from property records SRP / home estimates tab from Home page,
          // defaulting it to FOR SALE
          return status.forSale;
        }
      }
      else {
        return data.status;
      }
    };

    var isHomePageOrPropertyRecordSRP = function(){
      var criteria = MOVE.Helper.getSearchCriteriaFromCookie();
      var isHomePage = document.referrer.split('/')[3].length === 0;
      var isFROMPropertyRecordSRP = (criteria !== undefined && criteria.status === "8");
      return (isHomePage || isFROMPropertyRecordSRP);
    };

    onReady = function () {
      var ldpPage = $("." + controller + '.' + action);
      if (ldpPage.length === 1) {
        ldpPage.ready(
          monitorDom
        );
      }
    };

    var dragPhotoEvent = function() {
      $('#ldpPhotoMrect').addClass('hide');
      // Close commute time popover on photo gallery swipe
      MOVE.CommuteTime.closeCommutePopover();
    };

    var fillSearchBox = function(searchBoxValue){
      if(!isSameDomain() || _.isEmpty(searchBoxValue)){
        var propertyDetails = MOVE.DataStore.getData('propertyDetails');
        if(!(_.isEmpty(propertyDetails)) && !(_.isEmpty(propertyDetails.city)) && !(_.isEmpty(propertyDetails.state_code))){
          $('#searchBox').val(propertyDetails.city+', '+propertyDetails.state_code);
        }
        else if(_.isEmpty(propertyDetails.city) && !(_.isEmpty(propertyDetails.postal_code))){
          $('#searchBox').val(propertyDetails.postal_code);
        }
        else if(_.isEmpty(propertyDetails.postal_code)){
          $('#searchBox').val("");
        }
      }
      else if(searchBoxValue[0].areaType === 'address'){
        var recAddress = searchBoxValue[0].location.split(",");
        var address_str = recAddress[1] +','+ recAddress[2];
        $('#searchBox').val(address_str);
      }
      else{
        $('#searchBox').val(searchBoxValue[0].location);
      }
    };

    var monitorDom = function () {
      
      MOVE.LDP.CrabWalk.init();

      MOVE.Helper.pageLinking();

      // commute address search by smarty st
      MOVE.CommuteTime.init();

      // Set property status for LDP Search
      $.fn.autocomplete.setPropertyStatus(
        getPropertyStatus(LDP.model.data)
      );

      MOVE.CommuteTime.loadCommuteTime();

      //Do any page specific custom NR tracking
      MOVE.LDP.NrCustomPageViewTracking.init();
    };

    LDP.PropertyDetails = {
        init: init,
        dragPhotoEvent: dragPhotoEvent,
        fillSearchBox: fillSearchBox,
    };
    return LDP.PropertyDetails;
})(MOVE.LDP || {});


// WEBPACK FOOTER //
// ./ldp/common_platform/controllers/property_details.js